import { create } from 'zustand';
import {
  type TableFilterSlice,
  createTableFilterSlice,
} from './table-filter.slice';
import {
  type TableSelectionSlice,
  createTableSelectionSlice,
} from './table-selection.slice';

export const useGenericTableStore = create<
  TableSelectionSlice & TableFilterSlice & { resetStore: () => void }
>()((set, get, store) => ({
  ...createTableFilterSlice(set, get, store),
  ...createTableSelectionSlice(set, get, store),
  resetStore: () => set(store.getInitialState()),
}));
